import $ from 'jquery';
import BaseClass from './BaseClass';
import ImageChangeClass from '../load/ImageChangeClass';
import ImageLoadClass from '../load/ImageLoadClass';
import SvgChangeClass from '../load/SvgChangeClass';
import Util from '../util/Util';

let imageChangeCl = new ImageChangeClass();
let svgChangeCl = new SvgChangeClass();

/**
 * 実装時各ページの親になるクラス
 * 細かいイベントの監視などを一回で済ませるため
 * @param {String} _target 対象となるクラス名やid名なければbodyに変換
 */
export default class ParentClass extends BaseClass {
  constructor(_target) {
    super();
    this.name = 'ParentClass';
    this.target = (_target) ? _target : 'body';

    this.isCreate = false;
    this.isBlur = false;
    this.isLoad = false;
    this.isBreackPointCheckFirst = true;
    this.isFirstImageChange = true;
    this.isFirstSvgChange = true;

    this.isLoadEnd = false;
    this.isFirstImageChangeEnd = false;
    this.isFirstSvgChange = true;
    this.isAllLoadComplete = false;

    this.parts = {};
  }

  onCreate() {
    super.onCreate();
    this.isCreate = true;

    let self = this;

    // Util.isBreakpoint = (Util.getWindowSize().w <= Util.BREAK_POINT);
    Util.setBrowserName();
    Util.setOsName();

    if (Util.isAndroid) {
      $('html').addClass('isAndroid');
    }
    if (Util.isAndroid && !Util.isAndroidChrome) {
      $('html').addClass('isAndroid4');
    }

    Util.setAnchor($(this.target));

    $('.js-print').on('click', (e) => {
      e.preventDefault();
      window.print();
    });


    imageChangeCl.bind(imageChangeCl.EVENT_LOADEND, () => {
      if (self.isFirstImageChange) {
        self.isFirstImageChange = false;
        if (!self.isFirstSvgChange) { self.onFirstImageChangeEnd(); }
      }
      self.onResizeBefore(null, true);
    });

    imageChangeCl.onCreate($(this.target));


    svgChangeCl.bind(svgChangeCl.EVENT_LOADEND, () => {
      if (self.isFirstSvgChange) {
        self.isFirstSvgChange = false;
        if (!self.isFirstImageChange) {
          self.onFirstImageChangeEnd();
        }
      }
      self.onResizeBefore(null, true);
    });
    svgChangeCl.onCreate($(this.target));

    for (let k in this.parts) {
      this.parts[k].onCreate();
    }

    this.onResizeBefore();
    if (this.isLoad) { this.onLoad(); }

    $(window).on('resize orientationchange', () => {
      self.onResizeBefore();
    });
    $(window).on('blur pagehide', () => {
      self.onBlur();
    });
    $(window).on('focus pageshow', () => {
      self.onFocus();
    });
    $(window).on('scroll', () => {
      self.onScrollBefore();
    });

    window.onYouTubeIframeAPIReady = () => {
      self.onYouTubeIframeAPIReady();
    };
  }

  onLoad() {
    super.onLoad();
    this.isLoad = true;
    if (!this.isCreate) {
      return;
    }

    imageChangeCl.onLoad();
    svgChangeCl.onLoad();
    for (let k in this.parts) {
      this.parts[k].onLoad();
    }
    this.onResizeBefore();

    this.isLoadEnd = true;
    this.onImageLoadStart();
  }

  onResizeBefore(e, b) {
    if (!this.isCreate && !this.isLoad) {
      return;
    }
    let size = Util.getWindowSize();
    let scrollwidth = Util.getScrollWidth();
    if (size && size.w > 1024 && size.w <= 1392 && scrollwidth >= size.w) {
      $('html').addClass('w1392');
    }
    this.onResize(size, b);
  }

  onResize(_size, _b) {
    super.onResize(_size);
    Util.windowSize = _size;
    if (!_b) {
      imageChangeCl.onResize(_size);
      svgChangeCl.onResize(_size);
    }
    for (let k in this.parts) {
      this.parts[k].onResize(_size);
    }
    this.onChangeBreakPointBefore(_size);
    this.onScrollBefore();
  }

  onScrollBefore() {
    let st = Util.getScrollY();
    for (let k in this.parts) {
      this.parts[k].onScroll(st);
    }
    this.onScroll(st);
  }

  onScroll(_st) {
    super.onScroll();
  }

  onBlur() {
    super.onBlur();
    this.isBlur = true;
    for (let k in this.parts) {
      this.parts[k].onBlur();
    }
  }

  onFocus() {
    if (this.isBlur) { return; }
    super.onFocus();
    this.isBlur = false;
    for (let k in this.parts) {
      this.parts[k].onFocus();
    }
  }

  onChangeBreakPointBefore(_size) {
    /* let b = (_size.w <= Util.BREAK_POINT);

    if(b !== Util.isBreakpoint || this.isBreackPointCheckFirst){
      this.isBreackPointCheckFirst = false;
      Util.isBreakpoint = b;
      imageChangeCl.onChangeBreakPoint(b);
      svgChangeCl.onChangeBreakPoint(b);
      this.onChangeBreakPoint();
      for(let k in this.parts) this.parts[k].onChangeBreakPoint(b);
    }*/
  }

  onChangeBreakPoint() {
    super.onChangeBreakPoint();
  }

  onImageLoadEnd() {
    super.onImageLoadEnd();

    for (let k in this.parts) {
      this.parts[k].isImageLoadEnd = true;
      this.parts[k].onImageLoadEnd(true);
    }
    this.onResizeBefore();
  }

  onFirstImageChangeEnd() {
    this.isFirstImageChangeEnd = true;
    this.onImageLoadStart();
  }

  onImageLoadStart() {
    if (!this.isLoadEnd || !this.isFirstImageChangeEnd) {
      return;
    }
    let self = this;
    let imageLoad = new ImageLoadClass();
    imageLoad.bind(imageLoad.ONLOADEND, () => {
      self.onAllImageLoadComplete();
    });
    imageLoad.onLoad();
  }

  onAllImageLoadComplete() {
    this.isAllLoadComplete = true;
    this.onImageLoadEnd();
  }

  onYouTubeIframeAPIReady() {
    Util.isYoutubeApiReady = true;
    for (let k in this.parts) {
      this.parts[k].onYouTubeIframeAPIReady();
    }
  }
}
